export const SUPORTE_EMAIL = 'suporte@saldoativo.com.br';

const ASSUNTO_PADRAO = '[Suporte Saldo Ativo] ';

/**
 * Gera mailto com assunto padronizado e corpo mínimo para atendimento manual.
 * @param {{ emailConta?: string }} [opts]
 */
export function getSuporteMailto({ emailConta } = {}) {
  const bodyLines = [
    `E-mail da conta: ${emailConta || ''}`,
    '',
    'Descrição do problema:',
    '',
    '',
    '(Anexe um print no e-mail, se possível.)',
  ];
  const subject = encodeURIComponent(ASSUNTO_PADRAO);
  const body = encodeURIComponent(bodyLines.join('\n'));
  return `mailto:${SUPORTE_EMAIL}?subject=${subject}&body=${body}`;
}
